import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Style from "../../style/eventfilterleft.module.scss";

const EventFilterLeft = ({ itemList, onDateFilter }: any) => {
  const [showDropdown, setShowDropdown] = useState(true);
  const { type, city, category } = useParams();
  const [activeDateFilter, setActiveDateFilter] = useState<string | null>(null);

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const toSlug = (name: string) =>
    name.toLowerCase().replace(/ & /g, "-&-").replace(/\s+/g, "-");

  const isActive = (link: string, field: "category" | "city") => {
    const target = field === "category" ? type || category : city;
    return target ? toSlug(target) === toSlug(link) : false;
  };

  return (
    <div className={Style.container}>
      <div className={Style.LoginSection}>
        <h2>
          <a href="/login">Sign In</a> to unlock all features
        </h2>
      </div>

      <div className={Style.calenderSection}>
        <div className={Style.calendarToggle} onClick={toggleDropdown}>
          <h2>
            <i className="fa fa-calendar" style={{ marginRight: "8px" }}></i>
            Calendar
          </h2>
          <i className="fa-solid fa-caret-down"></i>
        </div>
        <div className={`${Style.dropdown} ${showDropdown ? Style.show : ""}`}>
          {[
            "today",
            "tomorrow",
            "this-week",
            "this-month",
            "next-3-months",
          ].map((label) => (
            <div
              key={label}
              onClick={() => {
                setActiveDateFilter(label);
                onDateFilter(label);
              }}
              className={`${Style.date} ${
                activeDateFilter === label ? Style.active : ""
              }`}
            >
              {label
                .replace(/-/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase())}
            </div>
          ))}
        </div>
      </div>

      <div className={Style.Category}>
        <h2>
          <i className="fa-solid fa-list"></i>Category
        </h2>
        {(
          Array.from(
            new Set(itemList.flatMap((item: any) => item.categories))
          ) as string[]
        ).map((cat, index) => (
          <a
            key={index}
            href={
              city
                ? `/event/${toSlug(cat)}/${toSlug(city)}`
                : `/event/category/${toSlug(cat)}`
            }
            className={isActive(cat, "category") ? Style.active : ""}
          >
            {cat}
          </a>
        ))}
      </div>

      <div className={Style.City}>
        <h2>
          <i className="fa-solid fa-location-dot"></i>Location
        </h2>
        {(
          Array.from(
            new Set(itemList.map((item: any) => item.venue.city))
          ) as string[]
        )
          .slice(0, 10)
          .map((cityName) => (
            <a
              key={cityName}
              href={
                type || category
                  ? `/event/${toSlug(type || category || "")}/${toSlug(
                      cityName
                    )}`
                  : `/event/city/${toSlug(cityName)}`
              }
              className={isActive(cityName, "city") ? Style.active : ""}
            >
              {cityName}
            </a>
          ))}
        <div className={Style.button}>
          <button>View All</button>
        </div>
      </div>

      <div className={Style.Type}>
        <h2>
          <i className="fa-solid fa-strikethrough"></i>Format
        </h2>
        {(
          Array.from(
            new Set(itemList.map((item: any) => item.tags[0]))
          ) as string[]
        ).map((tag, index) => (
          <a
            key={index}
            href={
              city
                ? `/event/${toSlug(tag)}/${toSlug(city)}`
                : `/event/format/${toSlug(tag)}`
            }
            className={isActive(tag, "category") ? Style.active : ""}
          >
            {tag.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
          </a>
        ))}
      </div>
      <div className={Style.Designation}>
        <h2>
          <i className="fa-solid fa-strikethrough"></i>Designation
        </h2>
        {(
          Array.from(
            new Set(
              itemList.map((item: any) => item.organizer.contact.designation)
            )
          ) as string[]
        ).map((tag, index) => (
          <a
            key={index}
            href={
              city
                ? `/event/${toSlug(tag)}/${toSlug(city)}`
                : `/event/designation/${toSlug(tag)}`
            }
            className={isActive(tag, "category") ? Style.active : ""}
          >
            {tag.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
          </a>
        ))}
      </div>
    </div>
  );
};

export default EventFilterLeft;
